import { render, staticRenderFns } from "./lgpd.vue?vue&type=template&id=e12f6032&scoped=true&"
import script from "./lgpd.vue?vue&type=script&lang=js&"
export * from "./lgpd.vue?vue&type=script&lang=js&"
import style0 from "./lgpd.vue?vue&type=style&index=0&id=e12f6032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12f6032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
